module.exports = __webpack_public_path__ + "img/social_style_3_rss-512-1.a85b64d9.png";